module.exports = __webpack_public_path__ + "img/banner.6d5f8c6c.jpg";